module.exports = __webpack_public_path__ + "img/xmsb7.4c43652f.png";